
import { ListViewProvider } from '../../../../../common/modules/apps/user-management/users-list/core/ListViewProvider'
import {AppointmentListTable} from './table/AppointmentListingTable'

const List = () => {
  return (
    <>
      <AppointmentListTable />
    </>
  )
}

const AppointmentListWrapper = () => (
  <ListViewProvider>
    <List />
  </ListViewProvider>
)

export {AppointmentListWrapper}
